import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Briefcase, ShoppingBag, Phone, Grid, LayoutGrid } from "lucide-react";
import "animate.css";

interface BottomNavBarProps {
    onPlusClick: () => void;
}

const BottomNavBar: React.FC<BottomNavBarProps> = ({ onPlusClick }) => {
    const navItems = [
        { path: "/", label: "Accueil", icon: Home },
        { path: "/services", label: "Services", icon: Briefcase },
        { path: "/projects", label: "Réalisations", icon: LayoutGrid },
        { path: "/boutique", label: "Boutique", icon: ShoppingBag },
    ];

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-dark/90 backdrop-blur-lg border-t border-white/15 safe-bottom animate__animated animate__fadeInUp">
            <div className="flex items-center justify-around py-1.5">
                {navItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) =>
                            `flex flex-col items-center gap-0.5 px-3 py-1 rounded-lg transition-all duration-200 ${isActive
                                ? "text-primary bg-white/5 scale-105"
                                : "text-white/90 hover:text-white/80 hover:bg-white/5"
                            }`
                        }
                    >
                        {({ isActive }) => (
                            <>
                                <item.icon size={20} strokeWidth={isActive ? 2 : 1.5} />
                                <span className="text-[10px] font-medium">{item.label}</span>
                            </>
                        )}
                    </NavLink>
                ))}

                <button
                    onClick={onPlusClick}
                    className="flex flex-col items-center gap-0.5 px-3 py-1 rounded-xl text-white/90 hover:text-white/80 hover:bg-white/5 transition-all duration-200 active:scale-95"
                >
                    <Grid size={20} strokeWidth={1.5} />
                    <span className="text-[10px] font-medium">Plus</span>
                </button>
            </div>
        </div>
    );
};

export default BottomNavBar;